import React from "react";
import { Dropdown } from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";

const LangSelector = ({ slug, lang = "ar" }) => {
  const newLang = lang === "ar" ? "en" : "ar";
  const location = useLocation();
  const navigate = useNavigate();
  let newLangUrl;

  // Handle root path case
  if (location.pathname === "/") {
    newLangUrl = `/${newLang}`;
  } else if (slug) {
    newLangUrl = `/${slug}/${newLang}${location.pathname.substring(
      location.pathname.indexOf(lang) + lang.length
    )}`;
  } else {
    // If we're in a path without a language prefix, add it
    if (!location.pathname.startsWith(`/${lang}`)) {
      newLangUrl = `/${newLang}${location.pathname}`;
    } else {
      newLangUrl = `/${newLang}${location.pathname.substring(
        location.pathname.indexOf(lang) + lang.length
      )}`;
    }
  }

  const handleLanguageChange = (e) => {
    e.preventDefault();
    // Preserve query parameters when switching languages
    const searchParams = location.search;
    navigate(`${newLangUrl}${searchParams}`);
  };

  return (
    <Dropdown style={dropdownStyles}>
      <Dropdown.Toggle
        variant="secondary"
        id="dropdown-basic"
        style={dropdownBtn}
      >
        {lang === "ar" ? "عربي" : "English"}
      </Dropdown.Toggle>

      <Dropdown.Menu
        aria-labelledby="dropdown-basic"
        style={{ maxWidth: "0 !important" }}
      >
        <Dropdown.Item>
          <Link style={dropdownBtn} to={`${newLangUrl}${location.search}`} onClick={handleLanguageChange}>
            {lang === "ar" ? "English" : "عربي"}
          </Link>
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
};

const dropdownStyles = {
  padding: "10px",
  background: "transparent",
};

const dropdownBtn = {
  backgroundColor: "transparent",
  color: "black",
  border: "none",
  textDecoration: "none",
};

export default LangSelector;
